import { MatChipsMultiSelectComponent } from './chips-multi-select/chips-multi-select.component';
import { MatChipsSelectComponent } from './chips-select/chips-select.component';

export const MAT_CUSTOM_COMPONENTS = [
  MatChipsMultiSelectComponent,
  MatChipsSelectComponent,
];
